import { MouseSensor } from "@dnd-kit/core"

// https://docs.dndkit.com/api-documentation/sensors#custom-sensors

// MouseSensor that blocks DnD event propagation if element have "data-no-dnd" attribute
export class CustomMouseSensor extends MouseSensor {
  static activators = [
    {
      eventName: "onMouseDown",
      handler: (event) => {
        let cur = event.target as HTMLElement

        while (cur) {
          if (cur.dataset && cur.dataset.noDnd) {
            return false
          }
          cur = cur.parentElement as HTMLElement
        }

        return true
      }
    }
  ] as typeof MouseSensor["activators"]
  autoScrollEnabled = false
}
